import { differenceInSeconds } from 'date-fns';
import * as moment from 'moment'

export const convertHexToRGB = (hex) => {
  // check if it's a rgba
  if (hex.match('rgba')) {
    let triplet = hex.slice(5).split(',').slice(0, -1).join(',');
    return triplet;
  }

  let c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('');
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = '0x' + c.join('');

    return [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',');
  }
};

export function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    }, wait);
    if (immediate && !timeout) func.apply(context, args);
  };
}

export function isMobile() {
  if (window) return window.matchMedia(`(max-width: 767px)`).matches;

  return false;
}

export function isMdScreen() {
  if (window) return window.matchMedia(`(max-width: 1199px)`).matches;

  return false;
}

function currentYPosition(elm) {
  if (!window && !elm) {
    return;
  }
  if (elm) return elm.scrollTop;
  // Firefox, Chrome, Opera, Safari
  if (window.pageYOffset) return window.pageYOffset;
  // Internet Explorer 6 - standards mode
  if (document.documentElement && document.documentElement.scrollTop)
    return document.documentElement.scrollTop;
  // Internet Explorer 6, 7 and 8
  if (document.body.scrollTop) return document.body.scrollTop;
  return 0;
}

function elmYPosition(elm) {
  var y = elm.offsetTop;
  var node = elm;
  while (node.offsetParent && node.offsetParent !== document.body) {
    node = node.offsetParent;
    y += node.offsetTop;
  }
  return y;
}

export function scrollTo(scrollableElement, elmID) {
  var elm = document.getElementById(elmID);

  if (!elmID || !elm) {
    return;
  }

  var startY = currentYPosition(scrollableElement);
  var stopY = elmYPosition(elm);

  var distance = stopY > startY ? stopY - startY : startY - stopY;
  if (distance < 100) {
    scrollTo(0, stopY);
    return;
  }
  var speed = Math.round(distance / 50);
  if (speed >= 20) speed = 20;
  var step = Math.round(distance / 25);
  var leapY = stopY > startY ? startY + step : startY - step;
  var timer = 0;
  if (stopY > startY) {
    for (var i = startY; i < stopY; i += step) {
      setTimeout(
        (function (leapY) {
          return () => {
            scrollableElement.scrollTo(0, leapY);
          };
        })(leapY),
        timer * speed
      );
      leapY += step;
      if (leapY > stopY) leapY = stopY;
      timer++;
    }
    return;
  }
  for (let i = startY; i > stopY; i -= step) {
    setTimeout(
      (function (leapY) {
        return () => {
          scrollableElement.scrollTo(0, leapY);
        };
      })(leapY),
      timer * speed
    );
    leapY -= step;
    if (leapY < stopY) leapY = stopY;
    timer++;
  }
  return false;
}

export function getTimeDifference(date) {
  let difference = differenceInSeconds(new Date(), date);

  if (difference < 60) return `${Math.floor(difference)} sec`;
  else if (difference < 3600) return `${Math.floor(difference / 60)} min`;
  else if (difference < 86400) return `${Math.floor(difference / 3660)} h`;
  else if (difference < 86400 * 30) return `${Math.floor(difference / 86400)} d`;
  else if (difference < 86400 * 30 * 12) return `${Math.floor(difference / 86400 / 30)} mon`;
  else return `${(difference / 86400 / 30 / 12).toFixed(1)} y`;
}

export function generateMongoQuery(filters) {
  filters = sanitize(filters);
  let newFilter = {};

  for (const key in filters) {
    if (filters.hasOwnProperty(key)) {
      const element = filters[key];
      let newKey = key;

      // if (key.indexOf("_like") > -1) {
      //   newKey = key.replace("_like", "");
      //   newFilter[newKey] = {
      //     ...newFilter[newKey],
      //     $like: `%${element}%`,
      //   };

      // }
      if (key.indexOf("_min") > -1) {
        newKey = key.replace("_min", "");
        newFilter[newKey] = {
          ...newFilter[newKey],
          $gte: element,
        };

      }
      else if (key.indexOf("_max") > -1) {
        newKey = key.replace("_max", "");
        newFilter[newKey] = {
          ...newFilter[newKey],
          $lte: element,
        };
      }
      else if (key.indexOf("_exact") > -1) {
        newKey = key.replace("_exact", "");
        newFilter[newKey] = element;
      }
      else if (key.indexOf("_bool") > -1) {
        newKey = key.replace("_bool", "");
        newFilter[newKey] = element;
      }
      else if (key.indexOf("deleted") > -1) {
        if (element === true) {
          newKey = key.replace("deleted", "deleted_at");
          newFilter[newKey] = {
            $not: null,
          };
        }

      }
      else if (key.indexOf("starts_at") > -1 && typeof element != 'object') {
        let date = element
        console.log(element)
        newFilter[key] = {
          $gte: moment(date).format('YYYY-MM-DD'),
          $lte: moment(date).add(1, 'day').format('YYYY-MM-DD'),
        }
        newFilter[key] = {
          ...newFilter[key],
          // $gte: moment(new Date()).subtract(element, "days"),
        };
      }
      // else if (key.indexOf("created_at") > -1 && typeof element != 'object') {
      //     let date = element
      //     console.log(element)
      //     newFilter[key] = {
      //       $gte: moment(date).format('YYYY-MM-DD'),
      //       $lte: moment(date).add(1, 'day').format('YYYY-MM-DD'),
      //     }
      //   newFilter[key] = {
      //     ...newFilter[key],
      //     // $gte: moment(new Date()).subtract(element, "days"),
      //   };
      // }
      else if (typeof element === 'object') {
        newFilter[key] = element;
      }
      else {
        newFilter[newKey] = { $like: `%${element}%` };
      }
    }
  }

  return newFilter;
}

export function sanitize(target) {
  if (typeof target === "object") {
    const santizedObject = {};
    for (const key in target) {
      if (target.hasOwnProperty(key)) {
        const element = target[key];
        if (!element && typeof element !== 'boolean') continue;
        if ((typeof element === "object" && !Array.isArray(element)) && Object.keys(element).length === 0) continue;
        if ((Array.isArray(element) && (element).length === 0)) continue;
        if (element == null) continue;
        santizedObject[key] = element;
      }
    }

    return santizedObject;
  }

  return target;
}

export function checkHasAccess(userRoles, roles) {
  if (!roles) return true;
  if (userRoles.includes("admin")) return true;
  if (userRoles.includes("sa")) return true;
  if (roles.includes("all")) return true;

  return userRoles.some((role) => roles.includes(role));
}

export function checkHasAccessToAction(action, hideActions, actions, roles) {
  if (roles.includes('sa') && !hideActions.includes(action)) return true;
  if (hideActions.includes(action)) return false;

  if (actions.length === 0) return true;

  return actions &&
    actions.length > 0 &&
    (
      (actions.map((a) => a.key).includes(action) &&
        checkHasAccess(roles, actions.filter((a) => a.key === action)[0].auth))

      || (!actions.map((a) => a.key).includes(action)))
}

export function mapNumberToFarsi(str) {
  if (str != null) {
    return str
      .toString()
      .replace(/[1234567890]/gi, e =>
        String.fromCharCode(e.charCodeAt(0) + 1728),
      );
  }
  return str;
}

export function daysBetween(date1, date2) {
  // The number of milliseconds in one day
  const ONE_DAY = 1000 * 60 * 60 * 24;

  // Calculate the difference in milliseconds
  const differenceMs = Math.abs(date1 - date2);

  // Convert back to days and return
  return Math.round(differenceMs / ONE_DAY);
}